export const HOW_LONG = 'Какие сроки доставки мебели?';
export const CUSTOM_SIZE = 'Можно ли заказать мебель по индивидуальным размерам?';
export const GUARANTEE = 'Какая гарантия на мебель и как происходит возврат?';
export const HOW_CHOOSE = 'Как выбрать мебель, чтобы она прослужила долго?';
